import React from 'react';

const TripleDropSpinner = () => (
  <div className="row pt-3 no-gutters">
    <div className="col text-center">
      <div className="spinner-grow text-primary" role="status" />
      <div
        className="spinner-grow text-primary"
        style={{ animationDelay: '0.1s' }}
        role="status"
      />
      <div
        className="spinner-grow text-primary"
        style={{ animationDelay: '0.2s' }}
        role="status"
      />
    </div>
  </div>
);

export default TripleDropSpinner;
